import { Injectable } from '@angular/core';
import { Http, Response, Headers, URLSearchParams, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import { RouteInfo } from "./sidebar.metadata";
import 'rxjs/add/operator/catch';
import { AppSettings } from '../../app.settings';
import { environment } from 'environments/environment.prod';
import { HttpHeaders } from '@angular/common/http';
import {WebServiceService} from "../../web-service.service";

@Injectable()
export class SidebarService {

    //Create constructor to get Http instance
    constructor(private httpService:WebServiceService) {

    }
    //Fetch all articles
    geMenus(){
        var token=JSON.parse(sessionStorage.getItem('currentUser'))['Auth-token'];
        const httpOptions = {
          headers : new HttpHeaders({
            // 'content-type'  : 'application/json',
            'Auth-Token':token
          })
        };
        return this.httpService.httpGet("userMenus?userId="+JSON.parse(sessionStorage.getItem("currentUser")).user_id);
    }

    private extractData(res: Response) {
	let body = res.json();
        return body;
    }
    private handleError (error: Response | any) {
	console.error(error.message || error);
	return Observable.throw(error.status);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/sidebar/sidebar.service.ts